import { getLabelWithDefaultStr } from '../../utils/i18n';

export const STAKE_STATUS = Object.freeze({
  upComing: 1,
  inComing: 2,
  ended: 3,
});

export const RateSubTitle = i18n => status => ({
  [STAKE_STATUS.upComing]: getLabelWithDefaultStr('exchange-staking-return-rate', i18n, '参考年回报率'),
  [STAKE_STATUS.inComing]: getLabelWithDefaultStr('exchange-staking-last-earning-rate', i18n, '上期折算收益率'),
  [STAKE_STATUS.ended]: getLabelWithDefaultStr('exchange-staking-calculated-earning-rate', i18n, '折算年回报率'),
})[status];

export const defaultStake = {
  totalRebateCoin: '0',
  stakingName: '-------',
  returnOfRate: '0;0',
  leastHoldCoin: '0',
  lastEarningRate: '0.0',
  thirtyDaysHoldCoin: '0',
  holdCoin: 'XXX',
  rebateCoin: 'XXX',
  startTime: '1970-01-01',
  endTime: '2046-12-25',
  status: STAKE_STATUS.inComing,
  tags: null,
  list: [],
  stakingDesc: 'desc',
};
